import styled from "@emotion/styled";
import { PDPHeadlineTypography } from "./pdp-headline-typography";
import { ReactTFC } from "../../utils/fp/missing-ts-parts";
import { css } from "@emotion/react";
import { CSS_MQ } from "../../styles/breakpoints";
import React from "react";
import cn from "classnames";

export const PDPHeadline = styled.h4`
  ${PDPHeadlineTypography};

  margin-top: 0;
  margin-bottom: 20px;

  &.margin-big {
    margin-bottom: 40px;
  }
`;

export const PDPHeadlineOnBackground: ReactTFC<{ children: React.ReactNode; color?: "inherit" | "green" }> = props => {
  return (
    <div
      className={"u-ta-center"}
      css={css`
        max-width: 100%;
        margin: 0 auto 20px;
        ${CSS_MQ.atLeastMd} {
          max-width: 80%;
          margin: 0 auto 40px;
        }
      `}
    >
      <PDPHeadline
        className={cn(props.color === "inherit" ? "color-inherit" : "", "u-text-balance")}
        css={css`
          margin: 0;
        `}
      >
        {props.children}
      </PDPHeadline>
    </div>
  );
};
